import React from "react";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Stack, Typography } from "@mui/material";

import { ROLE_TO_DISPLAY_NAME } from "@app/analytics/account/constants";
import OpenMenuButton from "@app/analytics/components/OpenMenuButton";
import TableCell from "@app/analytics/components/Table/TableCell";
import DropdownMenuItem from "@app/common/components/Dropdown/DropdownMenuItem";
import { EnterpriseRole } from "@app/common/workspaces/types";
import useAnchorElement from "@app/utils/hooks/useAnchorElement";

const RoleCell = ({
  disabled,
  onRoleChange,
  role,
  options = [],
}: {
  disabled: boolean;
  onRoleChange?: (role: EnterpriseRole) => void;
  role: EnterpriseRole;
  options?: EnterpriseRole[];
}) => {
  const anchorElement = useAnchorElement();

  const handleTeamRoleChange = (newRole: EnterpriseRole) => () => {
    if (!disabled && onRoleChange) {
      onRoleChange(newRole);
    }
    anchorElement.onClose();
  };

  return (
    <TableCell>
      <Stack direction="row" alignItems="center" sx={{ minWidth: "120px" }}>
        <OpenMenuButton
          {...anchorElement}
          buttonSx={{ ml: -1 }}
          component={
            <>
              <Typography
                variant="bodySecondaryReg"
                sx={{
                  color: "shades.neutral.500",
                  mr: 1,
                  fontFamily: (theme) => theme.typography.fontFamily,
                }}
              >
                {ROLE_TO_DISPLAY_NAME[role]}
              </Typography>
              {!disabled && (
                <ExpandMoreIcon
                  sx={{
                    width: "20px",
                    height: "20px",
                    color: anchorElement.open
                      ? "shades.primary.500"
                      : "shades.neutral.500",
                  }}
                />
              )}
            </>
          }
          disabled={disabled}
          id="user-team-role-select"
          menuItems={options.map((option) => {
            const isCurrentRole = option === role;
            return (
              <DropdownMenuItem
                key={option}
                onClick={handleTeamRoleChange(option)}
                selected={isCurrentRole}
                label={ROLE_TO_DISPLAY_NAME[option]}
                value={role}
                sx={{ width: "120px" }}
              />
            );
          })}
        />
      </Stack>
    </TableCell>
  );
};

export default RoleCell;
